var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xEB\\xCE\\xD3\\xC8_1",
    "data-name": "\\xEB\\xCE\\xD3\\xC8 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.1299,
    height: 278.5156,
    viewBox: "0 0 309.1299 278.5156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.2;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ebebeb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1433,189.3388a10.2847,10.2847,0,1,0,10.2845,10.2845A10.2844,10.2844,0,0,0,74.1433,189.3388Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.0788,199.6233a10.2847,10.2847,0,1,0-10.2845,10.2848A10.2845,10.2845,0,0,0,144.0788,199.6233Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.684,
    cy: 233.9964,
    r: 10.2846,
    transform: "translate(-36.1304 19.7901) rotate(-9.2175)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.8831,
    cy: 268.231,
    r: 10.2847,
    transform: "translate(-41.1853 25.5499) rotate(-9.2175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3048,84.8733A74.9159,74.9159,0,0,0,131.0335,42.0864a55.6143,55.6143,0,0,0-75.045,52.092,56.0971,56.0971,0,0,0,.3978,6.556,37.3091,37.3091,0,1,0-5.7094,74.1791h213.43a45.02,45.02,0,0,0,.1977-90.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,199.6233a10.2847,10.2847,0,1,0-10.2846,10.2848A10.2846,10.2846,0,0,0,203.73,199.6233Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.0962,189.3388a10.2847,10.2847,0,1,0,10.2846,10.2845A10.2845,10.2845,0,0,0,253.0962,189.3388Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.3351,
    cy: 233.9964,
    r: 10.2847,
    transform: "translate(-114.7377 296.2758) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5339,257.9464a10.2846,10.2846,0,1,0,10.2848,10.2846A10.2846,10.2846,0,0,0,197.5339,257.9464Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.9861,
    cy: 233.9964,
    r: 10.2847,
    transform: "translate(-77.9141 351.3862) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.6636,28.05A55.6146,55.6146,0,0,0,42.6185,80.1425a56.097,56.097,0,0,0,.398,6.556,37.3091,37.3091,0,1,0-5.7095,74.1791H150.9652V4.33A75.134,75.134,0,0,0,117.6636,28.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.7734,175.3029A10.2847,10.2847,0,1,0,71.058,185.5874,10.2845,10.2845,0,0,0,60.7734,175.3029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.709,185.5874a10.2847,10.2847,0,1,0-10.2846,10.2848A10.2846,10.2846,0,0,0,130.709,185.5874Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 91.3141,
    cy: 219.9605,
    r: 10.2846,
    transform: "translate(-34.0547 17.4672) rotate(-9.2175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.6805,219.9605a10.2847,10.2847,0,0,0,10.2847,10.2847V209.6758A10.2847,10.2847,0,0,0,140.6805,219.9605Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 124.5131,
    cy: 254.1951,
    r: 10.2846,
    transform: "translate(-157.9816 271.9538) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.9349,70.8374A74.9749,74.9749,0,0,0,150.9652,4.33V160.8776h99.772a45.02,45.02,0,0,0,.1977-90.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.36,185.5874a10.2847,10.2847,0,1,0-10.2846,10.2848A10.2846,10.2846,0,0,0,190.36,185.5874Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.7264,175.3029a10.2847,10.2847,0,1,0,10.2846,10.2845A10.2845,10.2845,0,0,0,239.7264,175.3029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.25,219.9605a10.2847,10.2847,0,0,0-10.2846-10.2847v20.5694A10.2847,10.2847,0,0,0,161.25,219.9605Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 184.1641,
    cy: 254.1951,
    r: 10.2846,
    transform: "translate(-121.1581 327.0641) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 210.6162,
    cy: 219.9605,
    r: 10.2847,
    transform: "translate(-73.2001 330.3694) rotate(-67.5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.c460a9dce89cc50407d9c829a0825750.svg";
export { ForwardRef as ReactComponent };